import { render, staticRenderFns } from "./Paper.vue?vue&type=template&id=254d0c2d&scoped=true"
import script from "./Paper.vue?vue&type=script&lang=js"
export * from "./Paper.vue?vue&type=script&lang=js"
import style0 from "./Paper.vue?vue&type=style&index=0&id=254d0c2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254d0c2d",
  null
  
)

export default component.exports